import script from "./PartnerRequestForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerRequestForm.vue?vue&type=script&setup=true&lang=js"

import "./PartnerRequestForm.vue?vue&type=style&index=0&id=f7c40852&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7c40852"]])

export default __exports__